/* eslint-disable import/prefer-default-export */

export const isLastIndex = (index, length) => index === length - 1
